import { queryClient } from 'app/App'
import { Store } from 'app/redux/Store'
import { isNil } from 'lodash'
import { FC } from 'react'

interface FormProjectAffiliationsErrorProps {
  error: any
  props: {
    item: any
    value: any
    langVersion: any
  }
}

export const FormProjectAffiliationsError: FC<FormProjectAffiliationsErrorProps> = (
  error: any,
  { item, value, langVersion }
): any => {
  // const { typeProps } = item
  // const roles = typeProps.roles || []
  const userLanguage = Store.getState().user?.language
  const contactRoleValues = queryClient.getQueryData(['contactRoles', userLanguage]) as Array<{ value: string, label: string }> | undefined

  if (Array.isArray(error)) {
    return {
      toMap: error
        .map((item, index) => {
          if (isNil(item)) {
            return null
          }
          const apiValue = value?.[index]?.apiValue
          const label = contactRoleValues?.find(role => role.value === apiValue)?.label
          return (
            <div key={index}>
              {index + 1}
              {'. '}
              {label}
              {': '}
              {Object.entries(item).map(([key, val]) => {
                return (
                  <span
                    key={key}
                    className='m-0 text-muted'
                    style={{ maxWidth: '771px' }}
                  >
                    {val}
                  </span>
                )
              })}
            </div>
          )
        })
        .filter((v) => v)
    }
  } else {
    return error
  }
}
